import React from 'react';

import * as S from './Loader.styles';
import * as B from '../DetailsBody/DetailsLeftBlock/BkngDetailsBlock/BkngDetailsBlock.styles';
import * as BI from '../DetailsBody/DetailsLeftBlock/BookingInfo/BookingInfo.styles';
import {HeaderMainWrap} from '../DetailsHeader/DetailsHeader.styles';
import {DetailBodyMainWrap} from '../DetailsBody/DetailsBody.styles';
import {LeftBlockMainWrap} from '../DetailsBody/DetailsLeftBlock/DetailsLeftBlock.styles';
import {RightBlockMainWrap} from '../DetailsBody/DetailsRightBlock/DetailsRightBlock.styles';
import {BkngOptionsOuterWrap, LeftHalfCircle, RightHalfCircle} from '../../common/BkngActions/BkngActions.styles';
import {MyTripsActionMainWrap, MyTripsActionInnerWrap} from '../../common/MyTripActions/MyTripActions.styles';

const MyTripsDetails = () => {
  return(
    <>
      <HeaderMainWrap>
        <S.StatusLoader></S.StatusLoader>
      </HeaderMainWrap>
      <DetailBodyMainWrap>
        <LeftBlockMainWrap>
          <B.BkngDetailMainWrap>
            <B.BkngDetailOuterWrap>
              <B.BkngDetailInnerWrap>
                <B.BkngHotelNameDetails>
                  <S.DetailStarLoader></S.DetailStarLoader>
                  <S.DetailHotelNameLoader></S.DetailHotelNameLoader>
                  <S.DetailAddressLoader></S.DetailAddressLoader>
                </B.BkngHotelNameDetails>
                <B.BkngDetailCheckInfo>
                  <B.CheckInfoWrap>
                    <S.CheckinLoader></S.CheckinLoader>
                    <B.CheckInfoDateWrap>
                      <S.CheckInfoDateLoader />
                      <B.CheckDateInnerWrap>
                        <S.CheckDateMonthLoader />
                        <S.CheckTimeLoader />
                      </B.CheckDateInnerWrap>
                    </B.CheckInfoDateWrap>
                  </B.CheckInfoWrap>

                  <B.StayNighsWrap>
                    <S.NightStayLoader />
                  </B.StayNighsWrap>

                  <B.CheckInfoWrap>
                    <S.CheckinLoader></S.CheckinLoader>
                    <B.CheckInfoDateWrap>
                      <S.CheckInfoDateLoader />
                      <B.CheckDateInnerWrap>
                        <S.CheckDateMonthLoader />
                        <S.CheckTimeLoader />
                      </B.CheckDateInnerWrap>
                    </B.CheckInfoDateWrap>
                  </B.CheckInfoWrap>
                </B.BkngDetailCheckInfo>
              </B.BkngDetailInnerWrap>
              <B.BkngHotelImgWrap>
                <S.HotelImgLoader />
                {/* <S.LocationImgLoader /> */}
              </B.BkngHotelImgWrap>
            </B.BkngDetailOuterWrap>

            <BkngOptionsOuterWrap>
              <LeftHalfCircle />
              <RightHalfCircle />
              <S.ActionLoader />
              <S.ActionLoader />
              <S.ActionLoader />
            </BkngOptionsOuterWrap>

          </B.BkngDetailMainWrap>

          <BI.TripBookingInfoWrap>
            <BI.TripBookingInfoHeaderWrap>
              <S.TripInfoHeaderLoader />
            </BI.TripBookingInfoHeaderWrap>

            <BI.TripBookingStatusWrap>
              <S.InfoLoader />
              <S.InfoLoaderSmall />
              <S.InfoLoader />
              <S.InfoLoaderSmall />
            </BI.TripBookingStatusWrap>
          </BI.TripBookingInfoWrap>

        </LeftBlockMainWrap>

        <RightBlockMainWrap>
          <MyTripsActionMainWrap>
            <MyTripsActionInnerWrap>
                <S.RightActionLoader />
                <S.RightSubActionLoader />
                <S.RightSubActionLoader />
                <S.RightSubActionLoader />
                <S.RightActionLoader />
                <S.RightSubActionLoader />
                <S.RightSubActionLoader />
                <S.RightSubActionLoader />
              {/* {(actionCategories.map(category => <ActionsCategoryLinks name={category} links={actionLinks[category]} key={category} />)) || null} */}
            </MyTripsActionInnerWrap>
          </MyTripsActionMainWrap>
        </RightBlockMainWrap>
      </DetailBodyMainWrap>
    </>
  );
}

export default MyTripsDetails;